<template><div><h1>VUX V2.1.1Rc.13 released</h1>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[fix] Support Group label styles #1110</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] Use gray for cancel text color</li>
</ul>
<h2><a href="/en/components/radio.html">Radio</a></h2>
<ul><li>[fix] Fix not support Number and not reactive #1115</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[feature] Add slot:right</li>
</ul>
<h2><a href="/en/components/step.html">Step</a></h2>
<ul><li>[fix] use export instead of module.exports</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[fix] fix After the call is not set webkitOverflowScrolling for touch</li>
</ul>
<h2><a href="/en/components/x-header.html">XHeader</a></h2>
<ul><li>[fix] Fix cannot set empty backText #1109 @erguotou520</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.13 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.13-79.vue?695abe16